// @flow

import React, { Component } from 'react';
import styled from 'styled-components';

import type { Message } from './SpecInput';
import type { SpecData } from '../utils/vortex/types';

import SpecInput from './SpecInput';
import SpecHeader from './SpecHeader';

const SpecsWrapper = styled.section`
  padding: 2em 1em 1em;
  @media (min-width: 375px) {
    padding: 2em 2em 1em;
  }
`;

type Props = {
  data: SpecData,
  focusFirst: boolean,
  inputs: Array<any>, // TODO: shouldn't be any
  messages: { [key: ?string]: Message },
  onChange: (string, mixed | void) => void,
  title: string
}

class Specs extends Component<Props> {

  static defaultProps = {
    focusFirst: false
  }

  render() {
    const { data, focusFirst, inputs, messages, title } = this.props;

    return (
      <SpecsWrapper>
        <SpecHeader>{title}</SpecHeader>
        <div>
          {
            inputs.map((input, i) => {
              const key = input.spec;
              const value = data[key];
              const message = messages[key];
              const autofocus = focusFirst && i === 0;
              return (
                <SpecInput
                  {...input}
                  key={key}
                  value={value}
                  onChange={this.props.onChange}
                  message={message}
                  autofocus={autofocus}
                  info={input.info || input.message}
                />
              );
            })
          }
        </div>
      </SpecsWrapper>
    );
  }

}

export default Specs;



// WEBPACK FOOTER //
// ./src/components/Specs.js